import { render, staticRenderFns } from "./KpiCardsClients.vue?vue&type=template&id=30703966&lang=pug&"
import script from "./KpiCardsClients.vue?vue&type=script&lang=js&"
export * from "./KpiCardsClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports